var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ChatMessageReference',{class:_vm.$style.content,attrs:{"message":_vm.currentPinnedMessage,"alter-title":_vm.alterTitle,"is-pinned":"","is-loading":_vm.isLoading},on:{"close":_vm.unpin},nativeOn:{"click":function($event){return _vm.next.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }